/**
 * 自選保單內容
 **/
import { store } from '@/store';
import _ from 'lodash';
import insurance from '@/utils/insurance';

const state = () => ({
    // 強制險
    compel: {
        ins21: {
            selected: false
        },
        ins147: {
            selected: false
        },
        ins47: {
            selected: false
        }
    },
    // 第三責任險
    lia: {
        group03: { // 超額責任險
            ins29: {
                selected: false,
                damageCover: {text: null, value: null}
            },
            ins30: {
                selected: false,
                damageCover: {text: null, value: null},
                deduct: {text: null, value: null}
            },
            ins301: {
                selected: false,
                injuredCover: {text: null, value: null},
                deduct: {text: null, value: null}
            }
        },
        group04: {
            ins31: {
                selected: false,
                injuredCover: {text: null, value: null},
                injuredCoverMultiple: {text: null, value: null}
            },
            ins32: {
                selected: false,
                damageCover: {text: null, value: null}
            }
        },
        group05: {
            ins231: {
                selected: false,
                injuredCover: {text: null, value: null},
                injuredCoverMultiple: {text: null, value: null}
            },
            ins232: {
                selected: false,
                damageCover: {text: null, value: null}
            }
        },
        group07: {
            ins113: {
                selected: false,
                injuredCover: {text: null, value: null},
                injuredCoverMultiple: {text: null, value: null}
            },
            ins114: {
                selected: false,
                damageCover: {text: null, value: null}
            },
            ins115: {
                selected: false,
                injuredCover: {text: null, value: null}
            }
        },
        ins27: {
            selected: false,
            damageCover: {text: null, value: null}
        },

        ins34: {
            selected: false,
            injuredCover: {text: null, value: null}
        },
        ins55: {
            selected: false,
            deathCover: {text: null, value: null}
        },
        group02: {
            ins56: {
                selected: false,
                damageCover: {text: null, value: null},
                medicalReimbursement: {text: null, value: null},
                remedyDailyPay: {text: null, value: null},
                insScope: {text: null, value: null}
            },
            ins166: {
                selected: false,
                damageCover: {text: null, value: null}
            }
        },
        ins164: {
            selected: false,
            damageCover: {text: null, value: null}
        },
        ins165: {
            selected: false,
            damageCover: {text: null, value: null}
        },
        ins109: {
            selected: false,
            deathCover: {text: null, value: null}
        },
        ins178: {
            selected: false,
            injuredCover: {text: null, value: null},
            deduct: {text: null, value: null}
        },
    },
    // 車體損失險
    damage: {
        group01: {
            ins01: {
                selected: false,
                deduct: {text: null, value: null}
            },
            ins05: {
                selected: false,
                deduct: {text: null, value: null}
            },
            ins09: {
                selected: false,
            },
            ins198: {
                selected: false,
            },
        },
        group06: {
            ins201: {
                selected: false,
                deduct: {text: null, value: null}
            },
            ins205: {
                selected: false,
                deduct: {text: null, value: null}
            },
            ins209: {
                selected: false,
            },
        },
        ins02: {
            selected: false,
        },
        ins07: {
            selected: false,
        },
        ins10: {
            selected: false,
        },
        ins62: {
            selected: false,
            qDay: {text: null, value: null}
        },
        ins63: {
            selected: false,
            qDay: {text: null, value: null}
        },
        ins64: {
            selected: false,
            qDay: {text: null, value: null}
        },
        ins161: {
            selected: false,
            damageCover: {text: null, value: null}
        },
        ins176: {
            selected: false,
            deduct: {text: null, value: null}
        },
        ins177: {
            selected: false,
            deduct: {text: null, value: null}
        },
        group08: {
            ins110: {
                selected: false,
                damageCover: {text: null, value: null}
            },
            ins111: {
                selected: false,
                damageCover: {text: null, value: null}
            },
        }
    },
    // 竊盜損失險
    theft: {
        ins11: {
            selected: false,
            deduct: {text: null, value: null}
        },
        ins211: {
            selected: false,
            deduct: {text: null, value: null}
        },
        ins17: {
            selected: false
        },
        ins12: {
            selected: false
        },
        ins28: {
            selected: false,
            damageCover: {text: null, value: null}
        },
        ins19: {
            selected: false,
            damageCover: {text: null, value: null}
        }
    },
    // 其他商品
    other: {
        ins15: {
            selected: false
        },
        ins237: {
            selected: false
        },
        ins238: {
            selected: false,
            injuredCover: {text: null, value: null},
            qDay: {text: null, value: null}
        },
        ins117: {
            selected: false,
            deathCover: {text: null, value: null}
        },
    }
});

const actions = {
    /**
     * 將已選取險種儲存到保單 store
     * @param state
     */
    save({state}) {

        store.commit('unselectInsurances');

        store.commit('ins21/select', state.compel.ins21.selected);
        store.commit('ins47/select', state.compel.ins47.selected);
        store.commit('ins147/select', state.compel.ins147.selected);

        store.commit('ins01/select', state.damage.group01.ins01.selected);
        store.commit('ins01/setDeduct', state.damage.group01.ins01.deduct);
        store.commit('ins05/select', state.damage.group01.ins05.selected);
        store.commit('ins05/setDeduct', state.damage.group01.ins05.deduct);
        store.commit('ins09/select', state.damage.group01.ins09.selected);
        store.commit('ins198/select', state.damage.group01.ins198.selected);
        store.commit('ins02/select', state.damage.ins02.selected);
        store.commit('ins07/select', state.damage.ins07.selected);
        store.commit('ins10/select', state.damage.ins10.selected);
        store.commit('ins62/select', state.damage.ins62.selected);
        store.commit('ins62/setQDay', state.damage.ins62.qDay);
        store.commit('ins63/select', state.damage.ins63.selected);
        store.commit('ins63/setQDay', state.damage.ins63.qDay);
        store.commit('ins64/select', state.damage.ins64.selected);
        store.commit('ins64/setQDay', state.damage.ins64.qDay);
        store.commit('ins161/select', state.damage.ins161.selected);
        store.commit('ins161/setDamageCover', state.damage.ins161.damageCover);
        store.commit('ins201/select', state.damage.group06.ins201.selected);
        store.commit('ins201/setDeduct', state.damage.group06.ins201.deduct);
        store.commit('ins205/select', state.damage.group06.ins205.selected);
        store.commit('ins205/setDeduct', state.damage.group06.ins205.deduct);
        store.commit('ins209/select', state.damage.group06.ins209.selected);
        store.commit('ins176/select', state.damage.ins176.selected);
        store.commit('ins176/setDeduct',state.damage.ins176.deduct);
        store.commit('ins177/select', state.damage.ins177.selected);
        store.commit('ins177/setDeduct',state.damage.ins177.deduct);
        store.commit('ins110/select', state.damage.group08.ins110.selected);
        store.commit('ins110/setDamageCover', state.damage.group08.ins110.damageCover);
        store.commit('ins111/select', state.damage.group08.ins111.selected);
        store.commit('ins111/setDamageCover', state.damage.group08.ins111.damageCover);

        store.commit('ins31/select', state.lia.group04.ins31.selected);
        store.commit('ins31/setInjuredCover', state.lia.group04.ins31.injuredCover);
        store.commit('ins31/setInjuredCoverMultiple', state.lia.group04.ins31.injuredCoverMultiple);
        store.commit('ins32/select', state.lia.group04.ins32.selected);
        store.commit('ins32/setDamageCover', state.lia.group04.ins32.damageCover);
        store.commit('ins27/select', state.lia.ins27.selected);
        store.commit('ins27/setDamageCover', state.lia.ins27.damageCover);
        store.commit('ins29/select', state.lia.group03.ins29.selected);
        store.commit('ins29/setDamageCover', state.lia.group03.ins29.damageCover);
        store.commit('ins30/select', state.lia.group03.ins30.selected);
        store.commit('ins30/setDamageCover', state.lia.group03.ins30.damageCover);

        let ins30Deduct = insurance.getCoverObj(store.getters['ins30/deductOptionsValid'], state.lia.group03.ins30.deduct.value);
        store.commit('ins30/setDeduct', insurance.getDefaultObj(ins30Deduct));

        store.commit('ins301/select', state.lia.group03.ins301.selected);
        store.commit('ins301/setInjuredCover', state.lia.group03.ins301.injuredCover);

        let ins301Deduct = insurance.getCoverObj(store.getters['ins301/deductOptionsValid'], state.lia.group03.ins301.deduct.value);
        store.commit('ins301/setDeduct', insurance.getDefaultObj(ins301Deduct));

        store.commit('ins34/select', state.lia.ins34.selected);
        store.commit('ins34/setInjuredCover', state.lia.ins34.injuredCover);

        let ins55number = store.state.estimate.TransportAmount || 4;
        let ins55damageCover = state.lia.ins55.deathCover.value * ins55number;

        store.commit('ins55/select', state.lia.ins55.selected);
        store.commit('ins55/setDeathCover', state.lia.ins55.deathCover);
        store.commit('ins55/setDamageCover', ins55damageCover);
        store.commit('ins56/select', state.lia.group02.ins56.selected);
        store.commit('ins56/setDamageCover', state.lia.group02.ins56.damageCover);
        store.commit('ins56/setInsScope', state.lia.group02.ins56.insScope);
        if (state.lia.group02.ins56.insScope.value === '2') {
            store.commit('ins56/setRemedyDailyPay', state.lia.group02.ins56.remedyDailyPay);
        } else {
            store.commit('ins56/setMedicalReimbursement', state.lia.group02.ins56.medicalReimbursement);
        }
        store.commit('ins109/select', state.lia.ins109.selected);
        store.commit('ins109/setDeathCover', state.lia.ins109.deathCover);
        store.commit('ins164/select', state.lia.ins164.selected);
        store.commit('ins164/setDamageCover', state.lia.ins164.damageCover);
        store.commit('ins165/select', state.lia.ins164.selected);
        store.commit('ins165/setDamageCover', state.lia.ins164.damageCover);
        store.commit('ins166/select', state.lia.group02.ins166.selected);
        store.commit('ins166/setDamageCover', state.lia.group02.ins166.damageCover);

        store.commit('ins113/select', state.lia.group07.ins113.selected);
        store.commit('ins113/setInjuredCover', state.lia.group07.ins113.injuredCover);
        store.commit('ins113/setInjuredCoverMultiple', state.lia.group07.ins113.injuredCoverMultiple);
        store.commit('ins114/select', state.lia.group07.ins114.selected);
        store.commit('ins114/setDamageCover', state.lia.group07.ins114.damageCover);
        store.commit('ins115/select', state.lia.group07.ins115.selected);
        store.commit('ins115/setInjuredCover', state.lia.group07.ins115.injuredCover);

        store.commit('ins231/select', state.lia.group05.ins231.selected);
        store.commit('ins231/setInjuredCover', state.lia.group05.ins231.injuredCover);
        store.commit('ins231/setInjuredCoverMultiple', state.lia.group05.ins231.injuredCoverMultiple);
        store.commit('ins232/select', state.lia.group05.ins232.selected);
        store.commit('ins232/setDamageCover', state.lia.group05.ins232.damageCover);
        store.commit('ins178/select', state.lia.ins178.selected);
        store.commit('ins178/setDeduct', state.lia.ins178.deduct);
        store.commit('ins178/setInjuredCover', state.lia.ins178.injuredCover);

        store.commit('ins11/select', state.theft.ins11.selected);
        store.commit('ins11/setDeduct', state.theft.ins11.deduct);
        store.commit('ins17/select', state.theft.ins17.selected);
        store.commit('ins12/select', state.theft.ins12.selected);
        store.commit('ins28/select', state.theft.ins28.selected);
        store.commit('ins28/setDamageCover', state.theft.ins28.damageCover);
        store.commit('ins19/select', state.theft.ins19.selected);
        store.commit('ins19/setDamageCover', state.theft.ins19.damageCover);
        store.commit('ins211/select', state.theft.ins211.selected);
        store.commit('ins211/setDeduct', state.theft.ins211.deduct);

        store.commit('ins15/select', state.other.ins15.selected);
        store.commit('ins237/select', state.other.ins237.selected);
        store.commit('ins238/select', state.other.ins238.selected);
        store.commit('ins238/setInjuredCover', state.other.ins238.injuredCover);
        store.commit('ins238/setQDay', state.other.ins238.qDay);
        store.commit('ins117/select', state.other.ins117.selected);
        store.commit('ins117/setDeathCover', state.other.ins117.deathCover);

    }
};

const getters = {
    active: (state, getters) => {
        return getters.liaSelected || getters.lia113Selected || getters.compelSelected || getters.damageSelected || getters.theftSelected || getters.otherSelected;
    },
    // 第三責任險選取狀態
    liaSelected: state => {
        return (state.lia.group04.ins31.selected && state.lia.group04.ins32.selected) || (state.lia.group05.ins231.selected && state.lia.group05.ins232.selected);
    },
    // 第三責任綜合險選取狀態
    lia113Selected: state => {
        return (state.lia.group07.ins113.selected && state.lia.group07.ins114.selected && state.lia.group07.ins115.selected);
    },
    // 強制險選取狀態
    compelSelected: state => {
        return state.compel.ins21.selected || state.compel.ins147.selected || state.compel.ins47.selected;
    },
    // 車體險選取狀態
    damageSelected: state => {
        return _.some(state.damage.group01, 'selected') || _.some(state.damage.group06, 'selected') || _.some(state.damage.group08, 'selected');
    },
    // 竊盜險選取狀態
    theftSelected: state => {
        return state.theft.ins11.selected || state.theft.ins211.selected;
    },
    // 其他險選取狀態
    otherSelected: state => {
        return _.some(state.other, 'selected');
    },
    group03Selected: state => {
        return state.lia.group03.ins29.selected || state.lia.group03.ins30.selected || state.lia.group03.ins301.selected;
    },
    group02Selected: state => {
        return state.lia.group02.ins56.selected || state.lia.group02.ins166.selected;
    }
};

const mutations = {
    setDataFromPolicy(state, payload) {

        // ins21
        state.compel.ins21.selected = store.state.ins21.selected;
        // ins147
        state.compel.ins147.selected = store.state.ins147.selected;
        // ins47
        state.compel.ins47.selected = store.state.ins47.selected;

        // ins31
        state.lia.group04.ins31.selected = store.state.ins31.selected;
        if(store.state.ins31.validData.InsType){
            let ins31InjuredCover = _.cloneDeep(_.first(store.getters['ins31/injuredCoverOptionsValid']));
            let ins31InjuredCoverMultiple = _.cloneDeep(_.first(store.getters['ins31/injuredCoverMultipleOptionsValid']));
            if (store.state.ins31.selected) {
                let _ins31InjureCoverValue = insurance.getCoverObj(store.getters['ins31/injuredCoverOptionsValid'], store.state.ins31.uploadForm.InjuredCover.toString());
                if (_ins31InjureCoverValue )ins31InjuredCover = _ins31InjureCoverValue;
                let _ins31InjuredCoverMultipleValue = insurance.getCoverObj(store.getters['ins31/injuredCoverMultipleOptionsValid'], (store.state.ins31.uploadForm.DamageCover / store.state.ins31.uploadForm.InjuredCover).toString(), '倍');
                if (_ins31InjuredCoverMultipleValue) ins31InjuredCoverMultiple = _ins31InjuredCoverMultipleValue;
            }
            state.lia.group04.ins31.injuredCover = insurance.getDefaultObj(ins31InjuredCover);
            state.lia.group04.ins31.injuredCoverMultiple = insurance.getDefaultObj(ins31InjuredCoverMultiple);
        }

        // ins32
        state.lia.group04.ins32.selected = store.state.ins32.selected;
        let ins32DamageCover = _.cloneDeep(_.first(store.getters['ins32/damageCoverOptionsValid']));
        if (store.state.ins32.selected){
            let _ins32DamageCoverValue = insurance.getCoverObj(store.getters['ins32/damageCoverOptionsValid'], store.state.ins32.uploadForm.DamageCover.toString());
            if (_ins32DamageCoverValue) ins32DamageCover = _ins32DamageCoverValue;
        }
        state.lia.group04.ins32.damageCover = insurance.getDefaultObj(ins32DamageCover);

        // ins29
        state.lia.group03.ins29.selected = store.state.ins29.selected;
        let ins29DamageCover = _.cloneDeep(_.first(store.getters['ins29/damageCoverOptionsValid']));
        if (store.state.ins29.selected) {
            let _ins29DamageCoverValue = insurance.getCoverObj(store.getters['ins29/damageCoverOptionsValid'], store.state.ins29.uploadForm.DamageCover.toString());
            if (_ins29DamageCoverValue) ins29DamageCover = _ins29DamageCoverValue;
        }

        state.lia.group03.ins29.damageCover = insurance.getDefaultObj(ins29DamageCover);

        // ins30
        state.lia.group03.ins30.selected = store.state.ins30.selected;
        let ins30DamageCover = _.cloneDeep(_.first(store.getters['ins30/damageCoverOptionsValid']));
        let ins30Deduct = {text: null, value: null};
        if (store.state.ins30.selected) {
            let _ins30DamageCoverValue = insurance.getCoverObj(store.getters['ins30/damageCoverOptionsValid'], store.state.ins30.uploadForm.DamageCover.toString());
            if (_ins30DamageCoverValue) ins30DamageCover = _ins30DamageCoverValue;
            let _ins30DeductValue = (store.state.ins30.uploadForm.Deduct * 1) <  4 ? 1 : 155;
            ins30Deduct = insurance.getCoverObj(store.getters['ins30/deductOptionsValid'], _ins30DeductValue.toString());
        }
        state.lia.group03.ins30.damageCover = insurance.getDefaultObj(ins30DamageCover);
        state.lia.group03.ins30.deduct = insurance.getDefaultObj(ins30Deduct);

        // ins301
        state.lia.group03.ins301.selected = store.state.ins301.selected;
        let ins301InjureCover = _.cloneDeep(_.first(store.getters['ins301/injuredCoverOptionsValid']));
        let ins301Deduct = {text: null, value: null};
        if (store.state.ins301.selected) {
            let _ins301InjureCoverValue = insurance.getCoverObj(store.getters['ins301/injuredCoverOptionsValid'], store.state.ins301.uploadForm.InjuredCover.toString());
            if (_ins301InjureCoverValue) ins301InjureCover = _ins301InjureCoverValue;
            let _ins301DeductValue = (store.state.ins301.uploadForm.Deduct * 1) <  4 ? 1 : 155;
            ins301Deduct = insurance.getCoverObj(store.getters['ins301/deductOptionsValid'], _ins301DeductValue.toString());
        }
        state.lia.group03.ins301.injuredCover = insurance.getDefaultObj(ins301InjureCover);
        state.lia.group03.ins301.deduct = insurance.getDefaultObj(ins301Deduct);

        // ins109
        state.lia.ins109.selected = store.state.ins109.selected;
        let ins109DeathCover = _.cloneDeep(_.first(store.getters['ins109/deathCoverOptionsValid']));
        if (store.state.ins109.selected) {
            let _ins109DeathCover = insurance.getCoverObj(store.getters['ins109/deathCoverOptionsValid'], store.state.ins109.uploadForm.DeathCover.toString());
            if (_ins109DeathCover) ins109DeathCover = _ins109DeathCover;
        }
        state.lia.ins109.deathCover = insurance.getDefaultObj(ins109DeathCover);

        //ins55
        state.lia.ins55.selected = store.state.ins55.selected;
        let ins55DeathCover = _.cloneDeep(_.first(store.getters['ins55/deathCoverOptionsValid']));
        if (store.state.ins55.selected) {
            let _ins55DeathCoverValue = insurance.getCoverObj(store.getters['ins55/deathCoverOptionsValid'], store.state.ins55.uploadForm.DeathCover.toString());
            if (_ins55DeathCoverValue) ins55DeathCover = _ins55DeathCoverValue;
        }
        state.lia.ins55.deathCover = insurance.getDefaultObj(ins55DeathCover);

        // ins56
        state.lia.group02.ins56.selected = store.state.ins56.selected;
        let ins56DamageCover = _.cloneDeep(_.first(store.getters['ins56/damageCoverOptionsValid']));
        let ins56MedicalReimbursement = _.cloneDeep(_.first(store.getters['ins56/medicalReimbursementOptionsValid']));
        let ins56RemedyDailyPay = _.cloneDeep(_.first(store.getters['ins56/remedyDailyPayOptionsValid']));
        let ins56InsScope = {text: null, value: null};
        if ( store.state.ins56.selected) {
            let _ins56DamageCoverValue = insurance.getCoverObj(store.getters['ins56/damageCoverOptionsValid'], store.state.ins56.uploadForm.DamageCover.toString());
            if (_ins56DamageCoverValue) ins56DamageCover = _ins56DamageCoverValue;
            let _medical = insurance.getCoverObj(store.getters['ins56/medicalReimbursementOptionsValid'], store.state.ins56.uploadForm.RemedyDailyPay.toString());
            if (_medical && store.state.ins56.uploadForm.InsScope == '3') ins56MedicalReimbursement = _medical;
            let _remedy = insurance.getCoverObj(store.getters['ins56/remedyDailyPayOptionsValid'], store.state.ins56.uploadForm.RemedyDailyPay.toString());
            if (_remedy && store.state.ins56.uploadForm.InsScope == '2') ins56RemedyDailyPay = _remedy;
            let _ins56InsScopeValue = insurance.getCoverObj(store.getters['ins56/insScopeOptionsValid'], store.state.ins56.uploadForm.InsScope.toString());
            if (_ins56InsScopeValue) ins56InsScope = _ins56InsScopeValue;
        }
        state.lia.group02.ins56.damageCover = insurance.getDefaultObj(ins56DamageCover);
        state.lia.group02.ins56.medicalReimbursement = insurance.getDefaultObj(ins56MedicalReimbursement);
        state.lia.group02.ins56.remedyDailyPay = insurance.getDefaultObj(ins56RemedyDailyPay);
        state.lia.group02.ins56.insScope = insurance.getDefaultObj(ins56InsScope);

        // ins166
        state.lia.group02.ins166.selected = store.state.ins166.selected;
        let ins166DamageCover = _.cloneDeep(_.first(store.getters['ins166/damageCoverOptionsValid']));
        if (store.state.ins166.selected) {
            let _ins166DamageCoverValue = insurance.getCoverObj(store.getters['ins166/damageCoverOptionsValid'], store.state.ins166.uploadForm.DamageCover.toString());
            if (_ins166DamageCoverValue) ins166DamageCover = _ins166DamageCoverValue;
        }
        state.lia.group02.ins166.damageCover = insurance.getDefaultObj(ins166DamageCover);

        // ins34
        state.lia.ins34.selected = store.state.ins34.selected;
        let ins34InjuredCover = _.cloneDeep(_.first(store.getters['ins34/injuredCoverOptionsValid']));

        if (store.state.ins34.selected) {
            let _ins34InjuredCover =  insurance.getCoverObj(store.getters['ins34/injuredCoverOptionsValid'], store.state.ins34.uploadForm.InjuredCover.toString());
            if (_ins34InjuredCover) ins34InjuredCover = _ins34InjuredCover;
        }
        state.lia.ins34.injuredCover = insurance.getDefaultObj(ins34InjuredCover);

        // ins27
        state.lia.ins27.selected  =store.state.ins27.selected;
        let ins27DamageCover = _.cloneDeep(_.first(store.getters['ins27/damageCoverOptionsValid']));
        if (store.state.ins27.selected) {
            let _ins27DamageCoverValue = insurance.getCoverObj(store.getters['ins27/damageCoverOptionsValid'], store.state.ins27.uploadForm.DamageCover.toString());
            if (_ins27DamageCoverValue) ins27DamageCover = _ins27DamageCoverValue;
        }
        state.lia.ins27.damageCover = insurance.getDefaultObj(ins27DamageCover);

        // ins164
        state.lia.ins164.selected  = store.state.ins164.selected;
        let ins164DamageCover = _.cloneDeep(_.first(store.getters['ins164/damageCoverOptionsValid']));
        if (store.state.ins164.selected) {
            let _ins164DamageCoverValue = insurance.getCoverObj(store.getters['ins164/damageCoverOptionsValid'], store.state.ins164.uploadForm.DamageCover.toString());
            if (_ins164DamageCoverValue) ins164DamageCover = _ins164DamageCoverValue;
        }
        state.lia.ins164.damageCover = insurance.getDefaultObj(ins164DamageCover);

        // ins231
        state.lia.group05.ins231.selected = store.state.ins231.selected;
        if(store.state.ins231.validData.InsType){
            let ins231InjuredCover = _.cloneDeep(_.first(store.getters['ins231/injuredCoverOptionsValid']));
            let ins231InjuredCoverMultiple = _.cloneDeep(_.first(store.getters['ins231/injuredCoverMultipleOptionsValid']));
            if (store.state.ins231.selected) {
                let _ins231InjureCoverValue = insurance.getCoverObj(store.getters['ins231/injuredCoverOptionsValid'], store.state.ins231.uploadForm.InjuredCover.toString());
                if (_ins231InjureCoverValue )ins231InjuredCover = _ins231InjureCoverValue;
                let _ins231InjuredCoverMultipleValue = insurance.getCoverObj(store.getters['ins231/injuredCoverMultipleOptionsValid'], (store.state.ins231.uploadForm.DamageCover / store.state.ins231.uploadForm.InjuredCover).toString(), '倍');
                if (_ins231InjuredCoverMultipleValue) ins231InjuredCoverMultiple = _ins231InjuredCoverMultipleValue;
            }
            state.lia.group05.ins231.injuredCover = insurance.getDefaultObj(ins231InjuredCover);
            state.lia.group05.ins231.injuredCoverMultiple = insurance.getDefaultObj(ins231InjuredCoverMultiple);
        }
        
        // ins232
        state.lia.group05.ins232.selected = store.state.ins232.selected;
        let ins232DamageCover = _.cloneDeep(_.first(store.getters['ins232/damageCoverOptionsValid']));
        if (store.state.ins232.selected){
            let _ins232DamageCoverValue = insurance.getCoverObj(store.getters['ins232/damageCoverOptionsValid'], store.state.ins232.uploadForm.DamageCover.toString());
            if (_ins232DamageCoverValue) ins232DamageCover = _ins232DamageCoverValue;
        }
        state.lia.group05.ins232.damageCover = insurance.getDefaultObj(ins232DamageCover);

        // ins178
        state.lia.ins178.selected  = store.state.ins178.selected;
        let ins178InjuredCover = _.cloneDeep(_.first(store.getters['ins178/injuredCoverOptionsValid']));
        let ins178Deduct = _.cloneDeep(_.first(store.getters['ins178/deductOptionsValid']));
        if (store.state.ins178.selected) {
            let _ins178InjureCoverValue = insurance.getCoverObj(store.getters['ins178/injuredCoverOptionsValid'], store.state.ins178.uploadForm.InjuredCover.toString());
            if (_ins178InjureCoverValue )ins178InjuredCover = _ins178InjureCoverValue;
            let _ins178DeductValue = insurance.getCoverObj(store.getters['ins178/deductOptionsValid'], store.state.ins178.uploadForm.Deduct.toString());
            if (_ins178DeductValue) ins178Deduct = _ins178DeductValue;
        }
        state.lia.ins178.injuredCover = insurance.getDefaultObj(ins178InjuredCover);
        state.lia.ins178.deduct = insurance.getDefaultObj(ins178Deduct);

        // ins113
        state.lia.group07.ins113.selected = store.state.ins113.selected;
        if(store.state.ins113.validData.InsType){
            let ins113InjuredCover = _.cloneDeep(_.first(store.getters['ins113/injuredCoverOptionsValid']));
            let ins113InjuredCoverMultiple = _.cloneDeep(_.first(store.getters['ins113/injuredCoverMultipleOptionsValid']));
            if (store.state.ins113.selected) {
                let _ins113InjureCoverValue = insurance.getCoverObj(store.getters['ins113/injuredCoverOptionsValid'], store.state.ins113.uploadForm.InjuredCover.toString());
                if (_ins113InjureCoverValue ) ins113InjuredCover = _ins113InjureCoverValue;
                let _ins113InjuredCoverMultipleValue = insurance.getCoverObj(store.getters['ins113/injuredCoverMultipleOptionsValid'], (store.state.ins113.uploadForm.DamageCover / store.state.ins113.uploadForm.InjuredCover).toString(), '倍');
                if (_ins113InjuredCoverMultipleValue) ins113InjuredCoverMultiple = _ins113InjuredCoverMultipleValue;
            }
            state.lia.group07.ins113.injuredCover = insurance.getDefaultObj(ins113InjuredCover);
            state.lia.group07.ins113.injuredCoverMultiple = insurance.getDefaultObj(ins113InjuredCoverMultiple);
        }
        // ins114
        state.lia.group07.ins114.selected = store.state.ins114.selected;
        let ins114DamageCover = _.cloneDeep(_.first(store.getters['ins114/damageCoverOptionsValid']));
        if (store.state.ins114.selected) {
            let _ins114DamageCoverValue = insurance.getCoverObj(store.getters['ins114/damageCoverOptionsValid'], store.state.ins114.uploadForm.DamageCover.toString());
            if (_ins114DamageCoverValue) ins114DamageCover = _ins114DamageCoverValue;
        }
        state.lia.group07.ins114.damageCover = insurance.getDefaultObj(ins114DamageCover);

        // ins115
        state.lia.group07.ins115.selected = store.state.ins115.selected;
        let ins115InjuredCover = _.cloneDeep(_.first(store.getters['ins115/injuredCoverOptionsValid']));

        if (store.state.ins115.selected) {
            let _ins115InjuredCover =  insurance.getCoverObj(store.getters['ins115/injuredCoverOptionsValid'], store.state.ins115.uploadForm.InjuredCover.toString());
            if (_ins115InjuredCover) ins115InjuredCover = _ins115InjuredCover;
        }
        state.lia.group07.ins115.injuredCover = insurance.getDefaultObj(ins115InjuredCover);
        
        // ins01
        state.damage.group01.ins01.selected = store.state.ins01.selected;
        let ins01Deduct = _.cloneDeep(_.first(store.getters['ins01/deductOptionsValid']));
        if (store.state.ins01.selected) {
            let _ins01DeductValue = insurance.getCoverObj(store.getters['ins01/deductOptionsValid'], store.state.ins01.uploadForm.Deduct.toString(), '01');
            if (_ins01DeductValue) ins01Deduct = _ins01DeductValue;
        }
        state.damage.group01.ins01.deduct = insurance.getDefaultObj(ins01Deduct);

        // ins05
        state.damage.group01.ins05.selected = store.state.ins05.selected;
        let ins05Deduct = _.cloneDeep(_.first(store.getters['ins05/deductOptionsValid']));
        if (store.state.ins05.selected) {
            let _ins05DeductValue =insurance.getCoverObj(store.getters['ins05/deductOptionsValid'], store.state.ins05.uploadForm.Deduct.toString());
            if (_ins05DeductValue) ins05Deduct = _ins05DeductValue;
        }
        state.damage.group01.ins05.deduct = insurance.getDefaultObj(ins05Deduct);

        // ins09
        state.damage.group01.ins09.selected = store.state.ins09.selected;

        // ins198
        state.damage.group01.ins198.selected = store.state.ins198.selected;

        // ins02
        state.damage.ins02.selected = store.state.ins02.selected;

        // ins07
        state.damage.ins07.selected = store.state.ins07.selected;

        // ins10
        state.damage.ins10.selected = store.state.ins10.selected;

        // ins62
        state.damage.ins62.selected = store.state.ins62.selected;
        let ins62QDay = _.cloneDeep(_.first(store.getters['ins62/qDayOptionsValid']));
        if (store.state.ins62.selected && store.state.ins62.uploadForm.QDay) {
            let _ins62QDayValue = insurance.getCoverObj(store.getters['ins62/qDayOptionsValid'], store.state.ins62.uploadForm.QDay.toString(), '天');
            if (_ins62QDayValue) ins62QDay = _ins62QDayValue;
        }
        state.damage.ins62.qDay = insurance.getDefaultObj(ins62QDay);

        // ins63
        state.damage.ins63.selected = store.state.ins63.selected;
        let ins63QDay = _.cloneDeep(_.first(store.getters['ins63/qDayOptionsValid']));
        if (store.state.ins63.selected && store.state.ins63.uploadForm.QDay) {
            let _ins63QDay = insurance.getCoverObj(store.getters['ins63/qDayOptionsValid'], store.state.ins63.uploadForm.QDay.toString(), '天');
            if (_ins63QDay) ins63QDay = _ins63QDay;
        }
        state.damage.ins63.qDay = insurance.getDefaultObj(ins63QDay);

        // ins64
        state.damage.ins64.selected = store.state.ins64.selected;
        let ins64QDay = _.cloneDeep(_.first(store.getters['ins64/qDayOptionsValid']));
        if (store.state.ins64.selected && store.state.ins64.uploadForm.QDay) {
            let _ins64QDay = insurance.getCoverObj(store.getters['ins64/qDayOptionsValid'], store.state.ins64.uploadForm.QDay.toString(), '天');
            if (_ins64QDay) ins64QDay = _ins64QDay;
        }
        state.damage.ins64.qDay = insurance.getDefaultObj(ins64QDay);

        // ins161
        state.damage.ins161.selected =  store.state.ins161.selected;
        let ins161DamageCover = _.cloneDeep(_.first(store.getters['ins161/damageCoverOptionsValid']));
        if (store.state.ins161.selected) {
            let _ins161DamageCover = insurance.getCoverObj(store.getters['ins161/damageCoverOptionsValid'], store.state.ins161.uploadForm.DamageCover.toString());
            if (_ins161DamageCover) ins161DamageCover = _ins161DamageCover;
        }
        state.damage.ins161.damageCover = insurance.getDefaultObj(ins161DamageCover);

        // ins201
        state.damage.group06.ins201.selected = store.state.ins201.selected;
        let ins201Deduct = _.cloneDeep(_.first(store.getters['ins201/deductOptionsValid']));
        if (store.state.ins201.selected) {
            let _ins201DeductValue = insurance.getCoverObj(store.getters['ins201/deductOptionsValid'], store.state.ins201.uploadForm.Deduct.toString(), '201');
            if (_ins201DeductValue) ins201Deduct = _ins201DeductValue;
        }

        state.damage.group06.ins201.deduct = insurance.getDefaultObj(ins201Deduct);
        
        // ins205
        state.damage.group06.ins205.selected = store.state.ins205.selected;
        let ins205Deduct = _.cloneDeep(_.first(store.getters['ins205/deductOptionsValid']));
        if (store.state.ins205.selected) {
            let _ins205DeductValue = insurance.getCoverObj(store.getters['ins205/deductOptionsValid'], store.state.ins205.uploadForm.Deduct.toString());
            if (_ins205DeductValue) ins205Deduct = _ins205DeductValue;
        }
        state.damage.group06.ins205.deduct = insurance.getDefaultObj(ins205Deduct);

        // ins209
        state.damage.group06.ins209.selected = store.state.ins209.selected;
        
        // ins176
        state.damage.ins176.selected = store.state.ins176.selected;
        let ins176Deduct = _.cloneDeep(_.first(store.getters['ins176/deductOptionsValid']));
        if (store.state.ins176.selected) {
            let _ins176DeductValue = insurance.getCoverObj(store.getters['ins176/deductOptionsValid'], store.state.ins176.uploadForm.Deduct.toString());
            if (_ins176DeductValue) ins176Deduct = _ins176DeductValue;
        }
        state.damage.ins176.deduct = insurance.getDefaultObj(ins176Deduct);
        
        // ins177
        state.damage.ins177.selected = store.state.ins177.selected;
        let ins177Deduct = _.cloneDeep(_.first(store.getters['ins177/deductOptionsValid']));
        if (store.state.ins177.selected) {
            let _ins177DeductValue = insurance.getCoverObj(store.getters['ins177/deductOptionsValid'], store.state.ins177.uploadForm.Deduct.toString());
            if (_ins177DeductValue) ins177Deduct = _ins177DeductValue;
        }
        state.damage.ins177.deduct = insurance.getDefaultObj(ins177Deduct);

        // ins110
        state.damage.group08.ins110.selected =  store.state.ins110.selected;
        let ins110DamageCover = _.cloneDeep(_.first(store.getters['ins110/damageCoverOptionsValid']));
        if (store.state.ins110.selected) {
            let _ins110DamageCover = insurance.getCoverObj(store.getters['ins110/damageCoverOptionsValid'], store.state.ins110.uploadForm.DamageCover.toString());
            if (_ins110DamageCover) ins110DamageCover = _ins110DamageCover;
        }
        state.damage.group08.ins110.damageCover = insurance.getDefaultObj(ins110DamageCover);

        // ins111
        state.damage.group08.ins111.selected =  store.state.ins111.selected; // 110 111一起
        let ins111DamageCover = _.cloneDeep(_.first(store.getters['ins111/damageCoverOptionsValid']));
        if (store.state.ins111.selected) {
            let _ins111DamageCover = insurance.getCoverObj(store.getters['ins111/damageCoverOptionsValid'], store.state.ins111.uploadForm.DamageCover.toString());
            if (_ins111DamageCover) ins111DamageCover = _ins111DamageCover;
        }
        state.damage.group08.ins111.damageCover = insurance.getDefaultObj(ins111DamageCover);
        
        // ins11
        state.theft.ins11.selected = store.state.ins11.selected;
        let ins11Deduct = _.cloneDeep(_.first(store.getters['ins11/deductOptionsValid']));
        if (store.state.ins11.selected) {
            let _ins11Deduct =  insurance.getCoverObj(store.getters['ins11/deductOptionsValid'], store.state.ins11.uploadForm.Deduct.toString());
            if (_ins11Deduct) ins11Deduct = _ins11Deduct;
        }
        state.theft.ins11.deduct = insurance.getDefaultObj(ins11Deduct);

        // ins17
        state.theft.ins17.selected = store.state.ins17.selected;

        // ins12
        state.theft.ins12.selected = store.state.ins12.selected;

        // ins28
        state.theft.ins28.selected = store.state.ins28.selected;
        let ins28DamageCover = _.cloneDeep(_.first(store.getters['ins28/damageCoverOptionsValid']));
        if (store.state.ins28.selected) {
            let _ins28DamageCover = insurance.getCoverObj(store.getters['ins28/damageCoverOptionsValid'], store.state.ins28.uploadForm.DamageCover.toString());
            if (_ins28DamageCover) ins28DamageCover = _ins28DamageCover;
        }
        state.theft.ins28.damageCover = insurance.getDefaultObj(ins28DamageCover);

        // ins19
        state.theft.ins19.selected = store.state.ins19.selected;
        let ins19DamageCover = _.cloneDeep(_.first(store.getters['ins19/damageCoverOptionsValid']));
        if (store.state.ins19.selected) {
            let _ins19DamageCover = insurance.getCoverObj(store.getters['ins19/damageCoverOptionsValid'], store.state.ins19.uploadForm.DamageCover.toString());
            if (_ins19DamageCover) ins19DamageCover = _ins19DamageCover;
        }
        state.theft.ins19.damageCover = insurance.getDefaultObj(ins19DamageCover);

        // ins211
        state.theft.ins211.selected = store.state.ins211.selected;
        let ins211Deduct = _.cloneDeep(_.first(store.getters['ins211/deductOptionsValid']));
        if (store.state.ins211.selected) {
            let _ins211Deduct =  insurance.getCoverObj(store.getters['ins211/deductOptionsValid'], store.state.ins211.uploadForm.Deduct.toString());
            if (_ins211Deduct) ins211Deduct = _ins211Deduct;
        }
        state.theft.ins211.deduct = insurance.getDefaultObj(ins211Deduct);

        // ins15
        state.other.ins15.selected = store.state.ins15.selected;

        // ins237
        state.other.ins237.selected = store.state.ins237.selected;

        // ins238
        state.other.ins238.selected = store.state.ins238.selected;
        let ins238InjuredCover = _.cloneDeep(_.first(store.getters['ins238/injuredCoverOptionsValid']));
        let ins238QDay = _.cloneDeep(_.first(store.getters['ins238/qDayOptionsValid']));
        if (store.state.ins238.selected) {
            let _ins238InjuredCover = insurance.getCoverObj(store.getters['ins238/injuredCoverOptionsValid'], store.state.ins238.uploadForm.InjuredCover.toString());
            if (_ins238InjuredCover) ins238InjuredCover = _ins238InjuredCover;
            let _ins238QDay = insurance.getCoverObj(store.getters['ins238/qDayOptionsValid'], store.state.ins238.uploadForm.QDay.toString(), '公里');
            if (_ins238QDay) ins238QDay = _ins238QDay;
        }
        state.other.ins238.injuredCover = insurance.getDefaultObj(ins238InjuredCover);
        state.other.ins238.qDay = insurance.getDefaultObj(ins238QDay);

        // ins117
        state.other.ins117.selected = store.state.ins117.selected;
        let ins117DeathCover = _.cloneDeep(_.first(store.getters['ins117/deathCoverOptionsValid']));
        if (store.state.ins117.selected) {
            let _ins117DeathCover = insurance.getCoverObj(store.getters['ins117/deathCoverOptionsValid'], store.state.ins117.uploadForm.DeathCover.toString());
            if (_ins117DeathCover) ins117DeathCover = _ins117DeathCover;
        }
        state.other.ins117.deathCover = insurance.getDefaultObj(ins117DeathCover);
    },
    /**
     *
     * @param state
     * @param payload Boolean
     */
    selectIns21(state, payload) {
        state.compel.ins21.selected = payload;
    },
    selectIns47(state, payload) {
        state.compel.ins47.selected = payload;
    },
    selectIns147(state, payload) {
        state.compel.ins147.selected = payload;
    },
    selectLia(state, payload) {
        state.lia.group04.ins32.selected = payload;
        state.lia.group04.ins31.selected = payload;
    },
    selectIns31(state, payload) { // 為了預勾31 32拆開
        state.lia.group04.ins31.selected = payload;
    },
    selectIns32(state, payload) { // 為了預勾31 32拆開
        state.lia.group04.ins32.selected = payload;
    },
    selectLiaForElectric(state, payload) {
        state.lia.group05.ins232.selected = payload;
        state.lia.group05.ins231.selected = payload;
    },
    selectIns231(state, payload) { // 為了預勾231 232拆開
        state.lia.group05.ins231.selected = payload;
    },
    selectIns232(state, payload) { // 為了預勾231 232拆開
        state.lia.group05.ins232.selected = payload;
    },
    selectLia113(state, payload) {
        state.lia.group07.ins113.selected = payload;
        state.lia.group07.ins114.selected = payload;
        state.lia.group07.ins115.selected = payload;
    },
    selectIns113(state, payload) { // 為了預勾113 114 115拆開
        state.lia.group07.ins113.selected = payload;
    },
    selectIns114(state, payload) { // 為了預勾113 114 115拆開
        state.lia.group07.ins114.selected = payload;
    },
    selectIns115(state, payload) { // 為了預勾113 114 115拆開
        state.lia.group07.ins115.selected = payload;
    },
    selectIns01(state, payload) {
        state.damage.group01.ins01.selected = payload;
    },
    setIns01Deduct(state, payload) {
        state.damage.group01.ins01.deduct.text = payload.text;
        state.damage.group01.ins01.deduct.value = payload.value;
    },
    selectIns02(state, payload) {
        state.damage.ins02.selected = payload;
    },
    selectIns05(state, payload) {
        state.damage.group01.ins05.selected = payload;
    },
    setIns05Deduct(state, payload) {
        state.damage.group01.ins05.deduct.text = payload.text;
        state.damage.group01.ins05.deduct.value = payload.value;
    },
    selectIns07(state, payload) {
        state.damage.ins07.selected = payload;
    },
    selectIns09(state, payload) {
        state.damage.group01.ins09.selected = payload;
    },
    selectIns10(state, payload) {
        state.damage.ins10.selected = payload;
    },
    selectIns11(state, payload) {
        state.theft.ins11.selected = payload;
    },
    selectIns12(state, payload) {
        state.theft.ins12.selected = payload;
    },
    selectIns17(state, payload) {
        state.theft.ins17.selected = payload;
    },
    selectIns19(state, payload) {
        state.theft.ins19.selected = payload;
    },
    setIns11Deduct(state, payload) {
        state.theft.ins11.deduct.value = payload.value;
        state.theft.ins11.deduct.text = payload.text;
    },
    setIns211Deduct(state, payload) {
        state.theft.ins211.deduct.value = payload.value;
        state.theft.ins211.deduct.text = payload.text;
    },
    setIns28DamageCover(state, payload) {
        state.theft.ins28.damageCover.text = payload.text;
        state.theft.ins28.damageCover.value = payload.value;
    },
    setIns19DamageCover(state, payload) {
        state.theft.ins19.damageCover.text = payload.text;
        state.theft.ins19.damageCover.value = payload.value;
    },
    selectIns27(state, payload) {
        state.lia.ins27.selected = payload;
    },
    selectIns28(state, payload) {
        state.theft.ins28.selected = payload;
    },
    selectIns29(state, payload) {
        state.lia.group03.ins29.selected = payload;
    },
    selectIns30(state, payload) {
        state.lia.group03.ins30.selected = payload;
    },
    selectIns34(state, payload) {
        state.lia.ins34.selected = payload;
    },
    selectIns55(state, payload) {
        state.lia.ins55.selected = payload;
    },
    selectIns56(state, payload) {
        state.lia.group02.ins56.selected = payload;
    },
    selectIns62(state, payload) {
        state.damage.ins62.selected = payload;
    },
    selectIns63(state, payload) {
        state.damage.ins63.selected = payload;
    },
    selectIns64(state, payload) {
        state.damage.ins64.selected = payload;
    },
    selectIns109(state, payload) {
        state.lia.ins109.selected = payload;
    },
    selectIns161(state, payload) {
        state.damage.ins161.selected = payload;
    },
    selectIns164(state, payload) {
        state.lia.ins164.selected = payload;
    },
    selectIns166(state, payload) {
        state.lia.group02.ins166.selected = payload;
    },
    selectIns198(state, payload) {
        state.damage.group01.ins198.selected = payload;
    },
    selectIns237(state, payload) {
        state.other.ins237.selected = payload;
    },
    selectIns238(state, payload) {
        state.other.ins238.selected = payload;
    },
    selectIns117(state, payload) {
        state.other.ins117.selected = payload;
    },
    setIns117DeathCover(state, payload) {
        state.other.ins117.deathCover.text = payload.text;
        state.other.ins117.deathCover.value = payload.value;
    },
    setIns238QDay(state, payload) {
        state.other.ins238.qDay.text = payload.text;
        state.other.ins238.qDay.value = payload.value;
    },
    setIns238InjuredCover(state, payload) {
        state.other.ins238.injuredCover.text = payload.text;
        state.other.ins238.injuredCover.value = payload.value;
    },
    selectIns301(state, payload) {
        state.lia.group03.ins301.selected = payload;
    },
    setIns30Deduct(state, payload) {
        state.lia.group03.ins30.deduct.value = payload.value;
        state.lia.group03.ins30.deduct.text = payload.text;
    },
    setIns31InjuredCover(state, payload) {
        state.lia.group04.ins31.injuredCover.text = payload.text;
        state.lia.group04.ins31.injuredCover.value = payload.value;
    },
    setIns31InjuredCoverMultiple(state, payload) {
        state.lia.group04.ins31.injuredCoverMultiple.text = payload.text;
        state.lia.group04.ins31.injuredCoverMultiple.value = payload.value;
    },
    setIns32DamageCover(state, payload) {
        state.lia.group04.ins32.damageCover.text = payload.text;
        state.lia.group04.ins32.damageCover.value = payload.value;
    },
    setIns56DamageCover(state, payload) {
        state.lia.group02.ins56.damageCover.text = payload.text;
        state.lia.group02.ins56.damageCover.value = payload.value;
    },
    setIns56RemedyDailyPay(state, payload) {
        state.lia.group02.ins56.remedyDailyPay.text = payload.text;
        state.lia.group02.ins56.remedyDailyPay.value = payload.value;
    },
    setIns56MedicalReimbursement(state, payload) {
        state.lia.group02.ins56.medicalReimbursement.text = payload.text;
        state.lia.group02.ins56.medicalReimbursement.value = payload.value;
    },
    setIns56InsScope(state, payload) {
        state.lia.group02.ins56.insScope.text = payload.text;
        state.lia.group02.ins56.insScope.value = payload.value;
    },
    setIns166DamageCover(state, payload) {
        state.lia.group02.ins166.damageCover.text = payload.text;
        state.lia.group02.ins166.damageCover.value = payload.value;
    },
    setIns27DamageCover(state, payload) {
        state.lia.ins27.damageCover.text = payload.text;
        state.lia.ins27.damageCover.value = payload.value;
    },
    setIns34InjuredCover(state, payload) {
        state.lia.ins34.injuredCover.text = payload.text;
        state.lia.ins34.injuredCover.value = payload.value;
    },
    setIns29DamageCover(state, payload) {
        state.lia.group03.ins29.damageCover.text = payload.text;
        state.lia.group03.ins29.damageCover.value = payload.value;
    },
    setIns30DamageCover(state, payload) {
        state.lia.group03.ins30.damageCover.text = payload.text;
        state.lia.group03.ins30.damageCover.value = payload.value;
    },
    setIns301InjuredCover(state, payload) {
        state.lia.group03.ins301.injuredCover.text = payload.text;
        state.lia.group03.ins301.injuredCover.value = payload.value;
    },
    setIns164DamageCover(state, payload) {
        state.lia.ins164.damageCover.text = payload.text;
        state.lia.ins164.damageCover.value = payload.value;
    },
    setIns165DamageCover(state, payload) {
        state.lia.ins165.damageCover.text = payload.text;
        state.lia.ins165.damageCover.value = payload.value;
    },
    setIns109DeathCover(state, payload) {
        state.lia.ins109.deathCover.text = payload.text;
        state.lia.ins109.deathCover.value = payload.value;
    },
    setIns55DeathCover(state, payload) {
        state.lia.ins55.deathCover.text = payload.text;
        state.lia.ins55.deathCover.value = payload.value;
    },
    setIns178InjuredCover(state, payload) {
        state.lia.ins178.injuredCover.text = payload.text;
        state.lia.ins178.injuredCover.value = payload.value;
    },
    setIns178Deduct(state, payload) {
        state.lia.ins178.deduct.text = payload.text;
        state.lia.ins178.deduct.value = payload.value;
    },
    setIns301Deduct(state, payload) {
        state.lia.group03.ins301.deduct.text = payload.text;
        state.lia.group03.ins301.deduct.value = payload.value;
    },
    selectIns201(state, payload) {
        state.damage.group06.ins201.selected = payload;
    },
    setIns201Deduct(state, payload) {
        state.damage.group06.ins201.deduct.text = payload.text;
        state.damage.group06.ins201.deduct.value = payload.value;
    },
    selectIns205(state, payload) {
        state.damage.group06.ins205.selected = payload;
    },
    setIns205Deduct(state, payload) {
        state.damage.group06.ins205.deduct.text = payload.text;
        state.damage.group06.ins205.deduct.value = payload.value;
    },
    selectIns209(state, payload) {
        state.damage.group06.ins209.selected = payload;
    },
    selectIns176(state, payload) {
        state.damage.ins176.selected = payload;
    },
    selectIns177(state, payload) {
        state.damage.ins177.selected = payload;
    },
    selectDamage110(state, payload) {
        state.damage.group08.ins110.selected = payload;
        state.damage.group08.ins111.selected = payload;
    },
    setIns161DamageCover(state, payload) {
        state.damage.ins161.damageCover.text = payload.text;
        state.damage.ins161.damageCover.value = payload.value;
    },
    setIns176Deduct(state, payload) {
        state.damage.ins176.deduct.text = payload.text;
        state.damage.ins176.deduct.value = payload.value;
    },
    setIns177Deduct(state, payload) {
        state.damage.ins177.deduct.text = payload.text;
        state.damage.ins177.deduct.value = payload.value;
    },
    setIns62QDay(state, payload) {
        state.damage.ins62.qDay.text = payload.text;
        state.damage.ins62.qDay.value = payload.value;
    },
    setIns63QDay(state, payload) {
        state.damage.ins63.qDay.text = payload.text;
        state.damage.ins63.qDay.value = payload.value;
    },
    setIns64QDay(state, payload) {
        state.damage.ins64.qDay.text = payload.text;
        state.damage.ins64.qDay.value = payload.value;
    },
    selectIns178(state, payload) {
        state.lia.ins178.selected = payload;
    },
    selectIns211(state, payload) {
        state.theft.ins211.selected = payload;
    },
    setIns231InjuredCover(state, payload) {
        state.lia.group05.ins231.injuredCover.text = payload.text;
        state.lia.group05.ins231.injuredCover.value = payload.value;
    },
    setIns231InjuredCoverMultiple(state, payload) {
        state.lia.group05.ins231.injuredCoverMultiple.text = payload.text;
        state.lia.group05.ins231.injuredCoverMultiple.value = payload.value;
    },
    setIns232DamageCover(state, payload) {
        state.lia.group05.ins232.damageCover.text = payload.text;
        state.lia.group05.ins232.damageCover.value = payload.value;
    },
    setIns113InjuredCover(state, payload) {
        state.lia.group07.ins113.injuredCover.text = payload.text;
        state.lia.group07.ins113.injuredCover.value = payload.value;
    },
    setIns113InjuredCoverMultiple(state, payload) {
        state.lia.group07.ins113.injuredCoverMultiple.text = payload.text;
        state.lia.group07.ins113.injuredCoverMultiple.value = payload.value;
    },
    setIns114DamageCover(state, payload) {
        state.lia.group07.ins114.damageCover.text = payload.text;
        state.lia.group07.ins114.damageCover.value = payload.value;
    },
    setIns115InjuredCover(state, payload) {
        state.lia.group07.ins115.injuredCover.text = payload.text;
        state.lia.group07.ins115.injuredCover.value = payload.value;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};